import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputEditorComponent } from './form-input-editor.component';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { SharedModule } from '../../../modules/shared/shared.module';
import { EditorModule } from 'primeng/editor';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FormInputEditorComponent
  ],
  imports: [
    CommonModule,
    FormInputErrorModule,
    SharedModule,
    EditorModule,
    FormsModule,
  ],
  exports: [
    FormInputEditorComponent
  ]
})
export class FormInputEditorModule { }
